module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('loginDialog', {
    attrs: {
      "show": _vm.loginShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-box"
  }, [_c('van-sticky', [_c('div', {
    staticClass: "header-search-box"
  }, [_c('van-search', {
    attrs: {
      "shape": "round",
      "background": "rgba(250,74,85,1)",
      "placeholder": "请输入搜索关键词"
    },
    on: {
      "click": _vm.onSearch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])], 1), _vm._v(" "), _vm._l((_vm.contentList), function(item, index) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(item.type == 'slidePics') ? _c('slidePics', {
      attrs: {
        "content": item.content,
        "top": _vm.top
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'navButton') ? _c('navButton', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'notice') ? _c('notice', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'pic') ? _c('pic', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'pics') ? _c('pics', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'goodsList0') ? _c('goodsList0', {
      attrs: {
        "content": item.content,
        "title": item.title
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'goodsList1') ? _c('goodsList1', {
      attrs: {
        "content": item.content,
        "title": item.title
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'goodsList2') ? _c('goodsList2', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'goodsList3') ? _c('goodsList3', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'goodsTabs1') ? _c('goodsTabs', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('TabBar', {
    attrs: {
      "show-tab-bar": true
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5733dd74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/GoodsIndex.vue
// module id = 2403
// module chunks = 0